<template>
    <div>

        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>操作记录列表</b></p>

            <!-- <p style="display:inline-block;line-height: 40px;margin: 5px 0;">
                <el-radio-group v-model="statusSearch" @input="searchByStatus">
                    <el-radio-button label="0">待产</el-radio-button>
                    <el-radio-button label="1">生产中</el-radio-button>
                    <el-radio-button label="2">暂停</el-radio-button>
                    <el-radio-button label="3">完成</el-radio-button>

                    <el-radio-button label="-1">全部</el-radio-button>
                </el-radio-group>
            </p> -->

            <el-select v-model="equipmentId" placeholder="请选择设备" style="width:220px" @change="monthChange">
                <el-option v-for="item in equipmentList" :key="item.value" :label="item.equipmentName" :value="item.id">
                </el-option>
            </el-select>


            <el-date-picker v-model="timeFrameValue" type="datetimerange" :picker-options="pickerOptions"
                @change="monthChange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right">
            </el-date-picker>

        </div>

        <el-table :data="logList" style="width: 100%" highlight-current-row>
            <el-table-column prop="equipmentCode" label="设备编号" min-width="20%">
            </el-table-column>

            <el-table-column prop="createdTime" label="操作时间" min-width="30%">
            </el-table-column>

            <el-table-column prop="operationType" label="操作类型" min-width="14%">
            </el-table-column>


            <el-table-column prop="totalWork" label="运行时长(m)" min-width="12%">
            </el-table-column>

            <el-table-column prop="totalPause" label="暂停时长(m)" min-width="12%">
            </el-table-column>

            <el-table-column prop="totalBad" label="故障时长(m)" min-width="12%">
            </el-table-column>

        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="10" :page-count="pageCount" layout="total, prev, pager, next"
                :total="total" @current-change="pageClick" hide-on-single-page>
            </el-pagination>
        </div>


    </div>
</template>

<script>
export default {
    name: "OperationLog",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),

            logList: [],

            // totalWork: 0,
            // totalPause: 0,
            // totalBad: 0,
            equipmentId: '',

            timeFrameValue: '',
            startTime: null,
            endTime: null,

            statusSearch: 0,

            pageIndex: 0,
            total: 0,
            pageCount: 0,

            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            }
        }
    },
    methods: {
        monthChange() {
            this.startTime = this.timeFrameValue[0]
            this.endTime = this.timeFrameValue[1]

            this.getAll()
        },
        searchByStatus(val) {

            this.getAll(val)
        },
        getAllEquip() {
            this.$axios({
                method: "post",
                url: "/shiro/equipment/getAll",
                data: {
                    id: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                this.equipmentList = data.data

            })
        },
        getAll(val) {

            // const formData = new FormData()
            // formData.append('status', val)

            // formData.append('companyId', this.companyId)
            // formData.append('pageIndex', this.pageIndex)
            // formData.append('pageNum', 10)

            this.$axios({
                method: "post",
                url: "/shiro/operation/getAll",
                data: {
                    companyId: this.companyId,
                    pageIndex: this.pageIndex,
                    pageNum: 10,
                    startTime: this.startTime,
                    endTime: this.endTime,
                    equipmentId: this.equipmentId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    });
                    return
                }

                this.logList = data.data
                this.total = this.logList[0].total
                this.pageCount = this.total % 10 == 0 ? this.total % 10 : this.total % 10 + 1

                // this.totalWork = this.logList[0].totalWork
                // this.totalPause = this.logList[0].totalPause
                // this.totalBad = this.logList[0].totalBad

                for (let i in this.logList) {
                    this.logList[i].createdTime = this.$moment(this.logList[i].createdTime).format("YYYY-MM-DD HH:mm:ss")

                    if (this.logList[i].operationType == 1) {
                        this.logList[i].operationType = '暂停'
                    } else if (this.logList[i].operationType == 2) {
                        this.logList[i].operationType = '运行'
                    } else {
                        this.logList[i].operationType = '故障'
                    }
                }
            })
        },
        pageClick(currentPage) {

            this.pageIndex = (currentPage - 1) * 10
            this.getAll(this.statusSearch)
        }
    },
    mounted() {
        this.getAll(this.statusSearch)

        this.getAllEquip()
    }
}
</script>

<style>
#order-header {
    height: 70px;
}

#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}
</style>